import React from "react";
import CustomTypography from "../../../globalStyles/fonts";

const FieldLabel = ({ children, required, style }) => (
  <CustomTypography
    style={{ textAlign: "left", fontWeight: 500, marginBottom: 1, ...style }}
    fontSize={14}
  >
    {children}
    {required && <span style={{ color: "red", marginLeft: 2 }}>*</span>}
  </CustomTypography>
);

export default FieldLabel;
